package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout

@Page
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun UserSupportPage() {
}